import { ProductBlockCapacityStatisticsComponent } from './components/product-block-capacity-statistics/product-block-capacity-statistics.component';
import { CustomerSearchTypeaheadComponent } from './components/customer-search-typeahead/customer-search-typeahead.component';
import { SelectboxComponent } from './../base-module/components/selectbox/selectbox.component';
import { RadioGroupComponent } from './../base-module/components/radio-group/radio-group.component';
import { PromiseIconComponent } from './../base-module/components/promise-icon/promise-icon.component';
import { CheckboxComponent } from './../base-module/components/checkbox/checkbox.component';
import { ButtonComponent } from './../base-module/components/button/button.component';
import { BaseComponentsModule } from './../base-module/base-components.module';
import { FeedbackFormComponent } from './common/feedback-form/feedback-form.component';
import { CustomerSeatCapacityEditorComponent } from './common/customer-seat-capacity-editor/customer-seat-capacity-editor.component';
import { CapacityEditorComponent } from './common/capacity-editor/capacity-editor.component';
import { HeaderSearchBarComponent } from './components/header-search-bar/header-search-bar.component';
import { TetherDialogComponent } from './modules/tether-dialog/tether-dialog.component';
import { SimpleTreeviewComponent } from './modules/simple-tree-view/simple-tree-view.component';
import { TetherDialogModule } from './modules/tether-dialog/tether-dialog.module';
import { WizardHeaderComponent } from './components/wizard-header/wizard-header.component';
import { VerticalKvListComponent } from './components/vertical-kv-list/vertical-kv-list.component';
import { VenueTemplateEditorComponent } from './components/venue-template-editor/venue-template-editor.component';
import { TypeaheadComponent } from './components/typeahead/typeahead.component';
import { TreeViewComponent } from './components/tree-view/tree-view.component';
import { TitleSwitcherComponent } from './components/title-switcher/title-switcher.component';
import { TextInputWithSelectComponent } from './components/text-input-with-select/text-input-with-select.component';
import { TagGroupComponent } from './components/tag-group/tag-group.component';
import { TabBarComponent } from './components/tab-bar/tab-bar.component';
import { SplitContainerComponent } from './components/split-container/split-container.component';
import { SortViewComponent } from './components/sort-view/sort-view.component';
import { SortTitleComponent } from './components/sort-title/sort-title.component';
import { SliderInputComponent } from './components/slider-input/slider-input.component';
import { SimpleProductListComponent } from './components/simple-product-list/simple-product-list.component';
import { ResponsiveTableComponent } from './components/responsive-table/responsive-table.component';
import { ProfilePhotoComponent } from './components/profile-photo/profile-photo.component';
import { ProductItemLineComponent } from './components/product-item-line/product-item-line.component';
import { PrimaryColumnLineComponent } from './components/primary-column-line/primary-column-line.component';
import { PillGroupComponent } from './components/pill-group/pill-group.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { OverImageStatsComponent } from './components/over-image-stats/over-image-stats.component';
import { NotificationBarComponent } from './components/notification-bar/notification-bar.component';
import { NoDataComponent } from './components/no-data/no-data.component';
import { NarrowInlineFeedbackComponent } from './components/narrow-inline-feedback/narrow-inline-feedback.component';
import { NarrowColStatusFeedbackComponent } from './components/narrow-col-status-feedback/narrow-col-status-feedback.component';
import { NarrowColActionOfferComponent } from './components/narrow-col-action-offer/narrow-col-action-offer.component';
import { NarrowClientDisplayComponent } from './components/narrow-client-display/narrow-client-display.component';
import { NarrowColActionBlockComponent } from './components/narrow-col-action-block/narrow-col-action-block.component';
import { MultiSelectionBarComponent } from './components/multi-selection-bar/multi-selection-bar.component';
import { MultiSelectGroupComponent } from './components/multi-select-group/multi-select-group.component';
import { ModalSearchBoxComponent } from './components/modal-search-box/modal-search-box.component';
import { MockBoxComponent } from './components/mock-box/mock-box.component';
import { MiniCardComponent } from './components/mini-card/mini-card.component';
import { MdEditorComponent } from './components/md-editor/md-editor.component';
import { MainMenuComponent } from './components/main-menu/main-menu.component';
import { InlineSearchInputComponent } from './components/inline-search-input/inline-search-input.component';
import { InlineEditComponent } from './components/inline-edit/inline-edit.component';
import { IconGridComponent } from './components/icon-grid/icon-grid.component';
import { HelperTextComponent } from './components/helper-text/helper-text.component';
import { HeaderLargeSearchComponent } from './components/header-large-search/header-large-search.component';
import { HeaderInlineEditComponent } from './components/header-inline-edit/header-inline-edit.component';
import { HeaderComponent } from './components/header/header.component';
import { GuestFormComponent } from './components/guest-form/guest-form.component';
import { GridListComponent } from './components/grid-list/grid-list.component';
import { GenericLoadingBoxComponent } from './components/generic-loading-box/generic-loading-box.component';
import { FullscreenCoverComponent } from './components/fullscreen-cover/fullscreen-cover.component';
import { FieldSearchBarComponent } from './components/field-search-bar/field-search-bar.component';
import { ExpandableBlockComponent } from './components/expandable-block/expandable-block.component';
import { DataSourceListComponent } from './components/data-source-list/data-source-list.component';
import { CustomerSearchBoxComponent } from './common/customer-search-box/customer-search-box.component';
import { CtaBoxComponent } from './components/cta-box/cta-box.component';
import { CoverImageComponent } from './components/cover-image/cover-image.component';
import { ContextMenuComponent } from './components/context-menu/context-menu.component';
import { ContainerRolloverActionsComponent } from './components/container-rollover-actions/container-rollover-actions.component';
import { ContainerCanvasComponent } from './components/container-canvas/container-canvas.component';
import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component';
import { ColorPickerComponent } from './components/color-picker/color-picker.component';
import { CollapsibleContainerComponent } from './components/collapsible-container/collapsible-container.component';
import { CityTownSelectorComponent } from './components/city-town-selector/city-town-selector.component';
import { CardItemComponent } from './components/card-item/card-item.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { BlockCapacityListComponent } from './components/block-capacity-list/block-capacity-list.component';
import { BasicButtonGroupComponent } from './components/basic-button-group/basic-button-group.component';
import { AvatarComponent } from './components/avatar/avatar.component';
import { AuthDialogBoxComponent } from './components/auth-dialog-box/auth-dialog-box.component';
import { ActionBoxComponent } from './components/action-box/action-box.component';
import { ContextMenuFilterComponent } from './components/context-menu-filter/context-menu-filter.component';
import { SimpleTreeviewModule } from './modules/simple-tree-view/simple-tree-view.module';
import { PipesModule } from './../pipes.module';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SingleTagComponent } from './components/single-tag/single-tag.component';
import { PdfViewerComponent } from './common/pdf-viewer/pdf-viewer.component';
import { EntitySearchBoxComponent } from './common/entity-search-box/entity-search-box.component';
import { PrintTicketV2Component } from './components/print-ticket-v2/print-ticket-v2.component';
import { ExpandableTreeBlockComponent } from './components/expandable-tree-block/expandable-tree-block.component';
import { TextInputGroupComponent } from './components/text-input-group/text-input-group.component';
import { NumberPickerComponent } from './components/number-picker/number-picker.component';
import { PhoneInputComponent } from './components/phone-input/phone-input.component';
import { AutocompleteComponent } from './components/autocomplete/autocomplete.component';
import { CustomerSearchSelectComponent } from './components/customer-search-select/customer-search-select.component';
import { BlockCapacityBoxComponent } from './common/block-capacity-box/block-capacity-box.component';
import { PageWizardHeaderComponent } from './components/page-wizard-header/page-wizard-header.component';
import { RelativeDateInputComponent } from './components/relative-date-input/relative-date-input.component';
import { UserCardContextComponent } from './common/user-card-context/user-card-context.component';
import { StatusTagComponent } from './components/status-tag/status-tag.component';

@NgModule({
  imports: [
    CommonModule, FormsModule, ReactiveFormsModule, RouterModule,
    PipesModule,
    BaseComponentsModule,
    SimpleTreeviewModule
  ],
  declarations: [
    CapacityEditorComponent,
    CustomerSearchBoxComponent,
    CustomerSeatCapacityEditorComponent,
    FeedbackFormComponent,

    ActionBoxComponent,
    AuthDialogBoxComponent,
    AvatarComponent,
    BasicButtonGroupComponent,
    BlockCapacityListComponent,
    BreadcrumbComponent,
    CardItemComponent,
    CityTownSelectorComponent,
    CollapsibleContainerComponent,
    ColorPickerComponent,
    ConfirmModalComponent,
    ContainerCanvasComponent,
    ContainerRolloverActionsComponent,
    ContextMenuComponent,
    CoverImageComponent,
    CtaBoxComponent,
    CustomerSearchTypeaheadComponent,
    DataSourceListComponent,
    ExpandableBlockComponent,
    FieldSearchBarComponent,
    FullscreenCoverComponent,
    GenericLoadingBoxComponent,
    GridListComponent,
    GuestFormComponent,
    HeaderComponent,
    HeaderInlineEditComponent,
    HeaderSearchBarComponent,
    HeaderLargeSearchComponent,
    HelperTextComponent,
    IconGridComponent,
    InlineEditComponent,
    InlineSearchInputComponent,
    MainMenuComponent,
    MdEditorComponent,
    MiniCardComponent,
    MockBoxComponent,
    ModalSearchBoxComponent,
    MultiSelectGroupComponent,
    ModalSearchBoxComponent,
    MultiSelectGroupComponent,
    MultiSelectionBarComponent,
    NarrowClientDisplayComponent,
    NarrowColActionBlockComponent,
    NarrowColActionOfferComponent,
    NarrowColStatusFeedbackComponent,
    NarrowInlineFeedbackComponent,
    NoDataComponent,
    NotificationBarComponent,
    OverImageStatsComponent,
    PaginationComponent,
    PillGroupComponent,
    PrimaryColumnLineComponent,
    ProductItemLineComponent,
    ProfilePhotoComponent,
    ResponsiveTableComponent,
    SimpleProductListComponent,
    SliderInputComponent,
    SortTitleComponent,
    SortViewComponent,
    SplitContainerComponent,
    TabBarComponent,
    TagGroupComponent,
    TextInputWithSelectComponent,
    TitleSwitcherComponent,
    TreeViewComponent,
    TypeaheadComponent,
    VenueTemplateEditorComponent,
    VerticalKvListComponent,
    WizardHeaderComponent,
    ContextMenuFilterComponent,
    SingleTagComponent,
    PdfViewerComponent,
    EntitySearchBoxComponent,
    PrintTicketV2Component,
    ExpandableTreeBlockComponent,
    TextInputGroupComponent,
    NumberPickerComponent,
    PhoneInputComponent,
    AutocompleteComponent,
    CustomerSearchSelectComponent,
    BlockCapacityBoxComponent,
    PageWizardHeaderComponent,
    RelativeDateInputComponent,
    UserCardContextComponent,
    StatusTagComponent,
    ProductBlockCapacityStatisticsComponent
  ],
  exports: [
    //Modules
    SimpleTreeviewComponent,

    //Commons
    CapacityEditorComponent,
    CustomerSearchBoxComponent,
    CustomerSeatCapacityEditorComponent,
    FeedbackFormComponent,

    //Components
    ActionBoxComponent,
    AuthDialogBoxComponent,
    AvatarComponent,
    BasicButtonGroupComponent,
    BlockCapacityListComponent,
    BreadcrumbComponent,
    CardItemComponent,
    CityTownSelectorComponent,
    CollapsibleContainerComponent,
    ColorPickerComponent,
    ConfirmModalComponent,
    ContainerCanvasComponent,
    ContainerRolloverActionsComponent,
    ContextMenuComponent,
    CoverImageComponent,
    CtaBoxComponent,
    CustomerSearchTypeaheadComponent,
    DataSourceListComponent,
    ExpandableBlockComponent,
    FieldSearchBarComponent,
    FullscreenCoverComponent,
    GenericLoadingBoxComponent,
    GridListComponent,
    GuestFormComponent,
    HeaderComponent,
    HeaderInlineEditComponent,
    HeaderSearchBarComponent,
    HeaderLargeSearchComponent,
    HelperTextComponent,
    IconGridComponent,
    InlineEditComponent,
    InlineSearchInputComponent,
    MainMenuComponent,
    MdEditorComponent,
    MiniCardComponent,
    MockBoxComponent,
    ModalSearchBoxComponent,
    MultiSelectGroupComponent,
    ModalSearchBoxComponent,
    MultiSelectGroupComponent,
    MultiSelectionBarComponent,
    NarrowClientDisplayComponent,
    NarrowColActionBlockComponent,
    NarrowColActionOfferComponent,
    NarrowColStatusFeedbackComponent,
    NarrowInlineFeedbackComponent,
    NoDataComponent,
    NotificationBarComponent,
    OverImageStatsComponent,
    PaginationComponent,
    PillGroupComponent,
    PrimaryColumnLineComponent,
    ProductItemLineComponent,
    ProfilePhotoComponent,
    ResponsiveTableComponent,
    SimpleProductListComponent,
    SliderInputComponent,
    SortTitleComponent,
    SortViewComponent,
    SplitContainerComponent,
    TabBarComponent,
    TagGroupComponent,
    TextInputWithSelectComponent,
    TitleSwitcherComponent,
    TreeViewComponent,
    TypeaheadComponent,
    VenueTemplateEditorComponent,
    VerticalKvListComponent,
    WizardHeaderComponent,
    ContextMenuFilterComponent,
    SingleTagComponent,
    EntitySearchBoxComponent,
    PrintTicketV2Component,
    ExpandableTreeBlockComponent,
    TextInputGroupComponent,
    NumberPickerComponent,
    PhoneInputComponent,
    AutocompleteComponent,
    CustomerSearchSelectComponent,
    PageWizardHeaderComponent,
    RelativeDateInputComponent,
    StatusTagComponent,
    ProductBlockCapacityStatisticsComponent
  ]
})

export class CommonComponentsModule { };


// WEBPACK FOOTER //
// ./src/app/modules/common-module/common-components.module.ts